//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TDP.js";
import "../no/Builder.js";
let d=[[[0,"Height",1,0],[0,"Length",1,0],[0,"Orientation",1,0],[0,"PageName",1,0],[0,"ShowPageNumber",1,0],[0,"StandardEnglishSize",1,0],[0,"StandardMetricSize",1,0]],[],[]];
SPLM.TDP.TemplatePageBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.TDP.TemplatePageBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.TDP.TemplatePageBuilder.OrientationType = Object.freeze({
    "Landscape" : "Landscape", "Portrait" : "Portrait"});

SPLM.TDP.TemplatePageBuilder.MetricSizeType = Object.freeze({
    "A0" : "A0", "A1" : "A1", "A2" : "A2", "A3" : "A3", "A4" : "A4", "Custom" : "Custom"});

SPLM.TDP.TemplatePageBuilder.EnglishSizeType = Object.freeze({
    "A" : "A", "B" : "B", "C" : "C", "D" : "D", "E" : "E", "F" : "F", "H" : "H", "J" : "J", "Custom" : "Custom"});

export default SPLM;